import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { filterFilledParams } from '../../../../../hooks/use-search-params'
import useAccountAddressFilter from '../../../hooks/use-account-address-filter'
import useMemberAddressData from '../../../hooks/use-member-address-data'
import { useAddAddressStore } from '../../../stores/add-address-store'
import Modal, { ModalBody } from '../../modal'
import AddAddressForm from './add-address-form'

const AddAddressModal = () => {
  const { idMember } = useSelector(state => state)
  const { search, page, limit } = useAccountAddressFilter()

  const paramsMemberAddress = useMemo(
    () =>
      filterFilledParams({
        member_id: idMember,
        keyword: search,
        page,
        limit,
      }),
    [idMember, search, page, limit]
  )

  const memberAddressData = useMemberAddressData(paramsMemberAddress)
  const zIndex = useAddAddressStore(s => s.zIndex)
  const open = useAddAddressStore(s => s.open)
  const closeModal = useAddAddressStore(s => s.closeModal)
  const isLoading =
    memberAddressData?.isLoading || memberAddressData?.isFetching

  useEffect(() => {
    if (!open) return

    const handlePopState = () => {
      // Block back
      window.history.pushState(null, document.title, window.location.href)
    }

    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [open])

  return (
    <Modal
      zIndex={zIndex}
      open={open}
      onClose={closeModal}
      disabled={isLoading}
      disableOutsideClick
      header={{ text: 'Tambah Alamat' }}
    >
      <ModalBody>
        <AddAddressForm />
      </ModalBody>
    </Modal>
  )
}

export default AddAddressModal
